
import ValidationResponse from "@/components/base/api/ValidationResponse"
import AccountVerification from "@/components/auth/AccountVerification"
import rules from "@/mixins/rules"
import SchoolBaseInput from "@/components/base/input/SchoolBaseInput"
import Button from "@/components/base/Button"
import Card from "@/components/base/card/Card"
import Footer from "@/components/layout/navigation/Footer"
import Vue from "vue"
import VueSmoothScroll from "vue2-smooth-scroll"
Vue.use(VueSmoothScroll)

export default {
    name: "SchoolRegistration",
    layout: "fullscreen",
    components: {
        Footer,
        Card,
        Button,
        SchoolBaseInput,
        AccountVerification,
        ValidationResponse,
    },
    meta: {
        footer: {
            showSchoolAgb: true,
        },
        toolbar: {
            hideSearch: true,
            persistent: true,
            hideLogin: true,
        },
    },
    mixins: [rules],
    async asyncData({ $axios }) {
        try {
            let result = await $axios.$get("/api/schools/number_of_schools")
            return {
                numberOfSchools: result.data,
            }
        } catch (e) {
            console.error(e)
        }
    },
    middleware: ["logged-out"],
    data: () => ({
        numberOfSchools: 30,
        featureCards: [
            {
                headline: "Ihr schwarzes Brett. Jetzt Digital.",
                text: "Zeigen Sie Ihren Schülern die beruflichen Möglichkeiten in der Region. Auf dem digitalen schwarzen Brett erscheinen die neuen Stellen und Angebote Ihrer Partnerfirmen automatisch. Um das Ausdrucken und Aufhängen der Stellenanzeigen brauchen Sie sich nicht mehr zu kümmern.",
            },
            {
                headline: "Praktikumswochen, so spannend wie nie.",
                text: "Ein spannendes zu finden Praktikum ist häufig Glückssache. Lassen Sie uns das gemeinsam ändern - damit Ihre Schüler:innen nicht mehr nur Kaffee kochen. Veröffentlichen Sie die Praktikumswoche Ihrer Schule auf Oabat. Firmen aus der Region bieten dann gezielt Praktika für Ihre Schüler:innen an. So haben Ihre Schüler:innen eine große Auswahl und informieren sich bereits vor der Bewerbung über das Praktikum.",
            },
            {
                headline: "Die Betriebserkundung kann starten.",
                text: "Eine spannende Betriebserkundung zu finden ist keine große Sache, wenn Ihre Schule einen Account bei Oabat hat. Durchstöbern Sie Betriebserkundungen, die Firmen in Ihrer Region anbieten. Ein Klick und schon erhält die Firma Ihre Anfrage. Alles weitere vereinbaren Sie bequem im Chat mit der Kontaktperson der Firma.",
            },
        ],
        responseData: null,
        currentStep: 1,
        registerSuccess: false,
        confirmAGB: false,
        confirmTeacher: false,
        user: {
            email: "",
            password: "",
            firstname: "",
            lastname: "",
            gender: "",
        },
        school: {
            base_id: "",
        },
        gender: [
            { name: "Frau", value: "female" },
            { name: "Herr", value: "male" },
            { name: "Divers", value: "else" },
        ],
    }),
    methods: {
        signup() {
            this.$smoothScroll({
                scrollTo: this.$refs["signupForm"],
                offset: -200,
                updateHistory: false,
            })
        },
        goToCreateAccountForm() {
            if (this.$refs.schoolSelectForm.validate()) {
                this.currentStep = 2
            }
        },
        selectSchool(item) {
            if (item) {
                this.school = item
            }
        },
        createAccount() {
            if (this.$refs.schoolAccountCreation.validate()) {
                this.$axios
                    .post("/api/schools/register", {
                        user: this.user,
                        school: { base_id: this.school.id },
                    })
                    .then(() => {
                        this.registerSuccess = true
                    })
                    .catch((error) => {
                        this.responseData = error.response.data
                    })
            }
        },
        onVerificationSuccess() {
            this.$store
                .dispatch("account/login", {
                    email: this.user.email,
                    password: this.user.password,
                })
                .then(() => {
                    if (this.$auth.user.school) {
                        this.$router.push("/schule")
                    } else {
                        this.$router.push(this.$auth.user.profile_path)
                    }
                })
        },
    },
}
